/* Altera Search — Reviews block.
   On /search pages, reads the section container's data-query,
   fetches matching reviews from the Mel Worker, and injects
   result cards. Hides itself + its nav pill when zero results.

   Wire format (Mel Worker /api/reviews/all):
     rating, review_text, customer_name, product (title),
     product_handle, submitted_date, featured, verified_purchase, images
   Response envelope: { ok, total_matched, reviews[] } */
(function () {
  'use strict';

  var WORKER_URL = (window.AlteraWishlistBoot && window.AlteraWishlistBoot.workerUrl)
    || 'https://mel-worker.melbel1313.workers.dev';
  var LIMIT = 6;

  function escHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function starsHtml(rating) {
    var v = Math.max(0, Math.min(5, +rating || 0));
    var pct = (v / 5) * 100;
    return '<span class="altera-mini-star-wrap">★★★★★' +
           '<span class="altera-mini-star-fill" style="width:' + pct + '%;">★★★★★</span>' +
           '</span>';
  }

  function truncate(s, words) {
    var str = String(s == null ? '' : s).trim();
    if (!str) return '';
    var parts = str.split(/\s+/);
    if (parts.length <= words) return parts.join(' ');
    return parts.slice(0, words).join(' ') + '…';
  }

  function highlight(text, q) {
    if (!q) return escHtml(text);
    var safe = escHtml(text);
    try {
      var re = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
      return safe.replace(re, '<mark class="altera-search-hl">$1</mark>');
    } catch (e) { return safe; }
  }

  function fmtDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  }

  function reviewIdFromGid(id) {
    if (!id) return '';
    var m = String(id).match(/\/(\d+)$/);
    return m ? m[1] : String(id).replace(/[^\w-]/g, '');
  }

  function reviewCard(r, q) {
    var text = r.review_text || '';
    var body = text
      ? '<div class="altera-search-review-body">' + highlight(truncate(text, 42), q) + '</div>'
      : '<div class="altera-search-review-body altera-search-review-body-empty">Rating only — no written review.</div>';
    var author = (r.customer_name && String(r.customer_name).trim())
      ? escHtml(r.customer_name) : 'Verified customer';
    var dateStr = fmtDate(r.submitted_date);
    var productName = (r.product && String(r.product).trim()) || r.product_handle || '';
    var productLink = '';
    if (r.product_handle) {
      productLink = '<a class="altera-search-review-product" href="/products/' +
        encodeURIComponent(r.product_handle) + '" data-stop>' +
        'View ' + escHtml(productName) + ' →</a>';
    }
    // Whole card links to the reviews page anchored to this review; the
    // product link inside intercepts its own click so both actions work.
    var rid = reviewIdFromGid(r.id);
    var href = '/pages/customer-reviews?q=' + encodeURIComponent(q) +
      (rid ? '#review-' + rid : '');
    return '' +
      '<a class="altera-search-review-card" href="' + href + '">' +
        '<div class="altera-search-review-head">' +
          starsHtml(r.rating) +
          '<span class="altera-search-review-meta">' + author + (dateStr ? ' · ' + dateStr : '') + '</span>' +
        '</div>' +
        body +
        productLink +
      '</a>';
  }

  function render(section, data, q) {
    var list = section.querySelector('[data-altera-reviews-list]');
    var moreWrap = section.querySelector('[data-altera-reviews-more]');
    var reviews = (data && data.reviews) || [];
    var total = (data && (data.total_matched != null ? data.total_matched : reviews.length)) || 0;

    if (!reviews.length) {
      section.hidden = true;
      return 0;
    }

    var html = '';
    for (var i = 0; i < reviews.length; i++) html += reviewCard(reviews[i], q);
    list.innerHTML = html;

    // Product-link inside a card is a real link; stop it from bubbling
    // into the outer card's navigation.
    var stops = list.querySelectorAll('[data-stop]');
    for (var j = 0; j < stops.length; j++) {
      stops[j].addEventListener('click', function (e) { e.stopPropagation(); });
    }

    if (moreWrap && total > reviews.length) {
      moreWrap.hidden = false;
    }

    section.hidden = false;

    // If native results were zero, the empty state was shown — hide it
    // now that we found something.
    var empty = document.querySelector('[data-altera-search-empty]');
    if (empty) empty.hidden = true;

    return total;
  }

  function updateNav(total) {
    var pill = document.querySelector('[data-altera-reviews-nav]');
    if (!pill) return;
    if (!total) { pill.hidden = true; return; }
    var countEl = pill.querySelector('[data-altera-reviews-count]');
    if (countEl) countEl.textContent = '(' + total + ')';
    pill.hidden = false;
  }

  function init() {
    var section = document.querySelector('[data-altera-search-reviews]');
    if (!section) return;
    var q = (section.getAttribute('data-query') || '').trim();
    if (!q) return;

    var url = WORKER_URL + '/api/reviews/all?q=' + encodeURIComponent(q) + '&limit=' + LIMIT + '&sort=newest';
    fetch(url, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.ok) { section.hidden = true; return; }
        var total = render(section, data, q);
        updateNav(total);
      })
      .catch(function () { section.hidden = true; });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
